<template>
  <nuttrema-menu-list>
    <template v-for="navigation in navigations">
      <nuttrema-menu-list-item
         v-if="navigation.pages && navigation.pages.length > 0"
        :class="{ 'is-active': isActive(navigation.url) }"
        theme="sidebar-menu">
        <el-popover
          placement="right"
          trigger="hover"
          width="200">
          <nuttrema-menu-list theme="popover-nav">
            <nuttrema-menu-list-item>
              <p class="list-item-label">{{ $t(navigation.label) }}</p>
            </nuttrema-menu-list-item>
            <section>
              <nuttrema-menu-list-item v-for="(page, childIndex) in navigation.pages" :key="page.url">
                <router-link
                   tag="a"
                   class="list-item-link"
                   activeClass="is-active"
                  :to="{ name: page.name, params: { id } }">
                  <span>{{ $t(page.label) }}</span>
                </router-link>
              </nuttrema-menu-list-item>
            </section>
          </nuttrema-menu-list>
          <nuttrema-iconica-sidebar-link
             slot="reference"
             theme="gray"
            :icon="navigation.navigationIcon"
            :title="$t(navigation.label)"
            :text="$t(navigation.label)"
            @mouseenter="$emit('mouseenter')"
            @click="$emit('click')">
          </nuttrema-iconica-sidebar-link>
        </el-popover>
      </nuttrema-menu-list-item>

      <nuttrema-menu-list-item v-else>
        <router-link
           tag="a"
           activeClass="is-active"
          :to="{ name: navigation.name, params: { id } }">
          <nuttrema-iconica-sidebar-link
             theme="gray"
            :icon="navigation.navigationIcon"
            :title="$t(navigation.label)"
            :text="$t(navigation.label)">
          </nuttrema-iconica-sidebar-link>
        </router-link>
           <!-- exact -->
      </nuttrema-menu-list-item>
    </template>
  </nuttrema-menu-list>
</template>


<script>
import SidebarMenu from './sidebar-menu';

export default {
  name: 'sidebar-menu-collapsed',
  mixins: [SidebarMenu],
  methods: {
    replaceID(value) {
      return value.replace(/{id}/g, this.id);
    },
    isActive(url) {
      return this.$route.path.startsWith(this.replaceID(url));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/menu/sidebar-menu-collapsed.vue